"use client";
import React from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { useTranslations } from "next-intl";

const LanguageLoadingOverlay = () => {
  const { isLoading } = useLanguage();
  const t = useTranslations();

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
      <div className="glass-effect rounded-lg p-6 flex flex-col items-center gap-4 shadow-lg">
        {/* Spinner */}
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#d9ac4f]"></div>

        {/* Loading Text */}
        <div className="text-center">
          <p className="text-[#D1D3D4] font-medium">
            {t("loading.changingLanguage")}
          </p>
          <p className="text-[#D1D3D4] text-sm mt-1">
            {t("loading.pleaseWait")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default LanguageLoadingOverlay;
